import { combineReducers } from "redux";
import { LayoutReducer } from "./LayoutReducer";

const rootReducer = combineReducers({
  portalData: LayoutReducer
});

export default rootReducer;